export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://storage.readdy-site.link/project_files/c4084cf6-f9fc-491d-816c-98ce35896c67/f0b80746-80f3-43ef-a546-af710736dea0_shutterstock_2135457873.jpg?v=8d22899ab5a0c34c9cdc0bc530bf56e5"
          alt="Families affected by Cardiospondylocarpofacial syndrome (CSCF) finding community and support"
          className="w-full h-full object-cover object-top"
        />
        {/* Warm sepia-blue cinematic overlay */}
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(160deg, rgba(30,45,80,0.72) 0%, rgba(60,50,40,0.55) 50%, rgba(20,35,65,0.70) 100%)',
          }}
        />
        {/* Subtle sepia tint layer */}
        <div
          className="absolute inset-0"
          style={{
            background: 'rgba(90,65,40,0.18)',
            mixBlendMode: 'multiply',
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center px-4 py-1.5 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full mb-6">
          <i className="ri-heart-pulse-line text-amber-200 mr-2 text-xs"></i>
          <span className="text-xs font-medium text-white/90 font-body">Ultra-Rare Genetic Condition Support</span>
        </div>

        {/* Headline */}
        <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-5 tracking-tight leading-tight font-heading">
          Connecting Families.<br />
          <span className="text-amber-200">Raising Awareness.</span><br />
          Supporting Research.
        </h1>

        {/* Subtext */}
        <p className="text-sm sm:text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed font-body px-2">
          Cardiospondylocarpofacial syndrome (CSCF) is an ultra-rare genetic condition affecting the heart, bones, hearing, and development — and no family should face it alone.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#about"
            className="group w-full sm:w-auto px-6 py-3 bg-white text-brand-600 font-semibold rounded-full hover:bg-amber-50 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer font-body text-sm"
          >
            <i className="ri-information-line"></i>
            <span>Learn About CSCF</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="https://www.facebook.com/share/g/1BT8NGBZVX/?mibextid=K35XfP"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-6 py-3 bg-white/15 backdrop-blur-sm border-2 border-white/50 text-white font-semibold rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer font-body flex items-center justify-center gap-2 text-sm"
          >
            <i className="ri-group-line"></i>
            <span>Join the Community</span>
          </a>
          <a
            href="#resources"
            className="w-full sm:w-auto px-6 py-3 bg-transparent border-2 border-white/30 text-white/85 font-semibold rounded-full hover:border-white/60 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer font-body flex items-center justify-center gap-2 text-sm"
          >
            <i className="ri-hand-heart-line"></i>
            <span>Find Support</span>
          </a>
        </div>

        {/* Stats row */}
        <div className="mt-10 pt-8 border-t border-white/15 flex flex-row items-center justify-center gap-8 sm:gap-20">
          {[
            { value: '<30', label: 'Cases Worldwide' },
            { value: '6', label: 'Case Studies' },
            { value: '2016', label: 'Gene Identified' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl sm:text-4xl font-bold text-white font-heading">{stat.value}</div>
              <div className="text-xs text-white/55 mt-1 font-body tracking-wide">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-white/50"></i>
      </div>
    </section>
  );
}
